import { showErrorAlert } from '../helpers/alert';
import apiClient from '../helpers/apiClient'
import { handleApiError, parseApiErrors } from '../utils/handleApiError';

export const updateProfile = async (data: any, memberId?: string) => {
    try {
        const url = memberId
            ? `/admin-profile/basic/${memberId}/`
            : `/admin-profile/basic/`;
        const response = await apiClient.put(url, data)
        return response.data
    } catch (error) {
        handleApiError(error, {});
    }
}

export async function updateProfileImg(image: File, memberId?:number) {
    const formData = new FormData()
    formData.append('profile_picture', image)

    const { data } = await apiClient.patch(`/admin/members/${memberId}/picture/`, formData, {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'multipart/form-data',
        },
    })

    return data
}

export const updateProfileProfessional = async (data: any, memberId?: string) => {
    try {
        const getYear = (value: string, isCurrent?: boolean): string => {
            if (isCurrent) return 'Present'
            if (!value) return ''
            return new Date(value).getFullYear().toString()
        }
        const payload = {
            professional_profile: {...data},
        }
        const url = memberId
            ? `/admin-profile/${memberId}/`
            : `/admin-profile/`;
        const response = await apiClient.patch(url, payload)
        return response.data
    } catch (error: any) {
        handleApiError(error, {});
    }
}

export const updateProfilePersonal = async (data: any, memberId?: string) => {
    try {
        const payload = {
            personal_detail: {...data},
        }
        const url = memberId
            ? `/admin-profile/${memberId}/`
            : `/admin-profile/`;
        const response = await apiClient.patch(url, payload)
        return response.data
    } catch (error) {
        handleApiError(error, {});
    }
}

export const updateProfileConfidential = async (data: any, memberId?: string) => {
    try {
        const url = memberId
            ? `/admin-profile/confidential/${memberId}/`
            : `/admin-profile/confidential/`;
        const response = await apiClient.put(url, data)
        return response.data
    } catch (error) {
        handleApiError(error, {});
    }
}

export const activateDeactivateAdminMember = async (memberId?:number, isActive?:boolean) => {
    try {
        const response = await apiClient.patch(`/admin/members/${memberId}/`, {user_is_active: isActive ? true : false})
        return response.data
    } catch (error) {
        handleApiError(error, {});
    }
}

export async function getExperiencesByUser(id:number,params:any={}) {
    try {
        const response = await apiClient.get(`/experiences/user/${id}/list/`, { params: params });
        return response.data;
    } catch (error) {
        handleApiError(error, {});
        return [];
    }
}